"use client"

import {
  StatusBadge as PackageStatusBadge,
  type StatusBadgeProps,
} from "@exxatdesignux/ui/components/status-badge"

export * from "@exxatdesignux/ui/components/status-badge"

/**
 * Icon chips use `md` unless the caller sets `size` or `surface`.
 * Label-only chips stay `sm`.
 */
export function StatusBadge(props: StatusBadgeProps) {
  if (
    "label" in props &&
    props.icon &&
    props.size == null &&
    props.surface == null
  ) {
    return <PackageStatusBadge {...props} size="md" />
  }
  return <PackageStatusBadge {...props} />
}
